export default function () {
  const { innerHeight, innerWidth, visualViewport } = window;
  const dimensions = {
    innerWidth,
    innerHeight,
  };
  if (visualViewport) {
    const { width, height } = visualViewport;
    dimensions.innerWidth = width;
    dimensions.innerHeight = height;
  }

  return dimensions;
}
